import { Component, forwardRef, OnInit } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { UserActionBaseComponent } from "../userAction-base.component";
import { LoginService } from "app/Services/login.service";
import { MacroService } from "app/Services/CatalogManagement/macro.service";
import { JobService } from "app/Services/job.service";
import { TranslateService } from "@ngx-translate/core";
import { CatalogService } from "app/Services/CatalogManagement/catalog.service";
import { ClassificationService } from "app/Services/classification.service";
import { ClassificationSystem } from "app/Model/classification/ClassificationSystem";

@Component({
    selector: "userAction-updateClassification",
    templateUrl: "userAction-updateClassification.component.html",
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UserActionUpdateClassificationComponent) }
    ],
    standalone: false
})
export class UserActionUpdateClassificationComponent extends UserActionBaseComponent implements OnInit {

    classificationSystems: ClassificationSystem[] = [];
    selectedClassificationSystemId: string = "";

    constructor(
        public loginService: LoginService,
        public macroService: MacroService,
        public jobService: JobService,
        public translate: TranslateService,
        public catalogService: CatalogService,
        private classificationService: ClassificationService
    ) {
        super(loginService, macroService);
    }

    async ngOnInit() {
        super.ngOnInit();
        this.classificationSystems = await lastValueFrom(
            this.classificationService.getClassificationSystemsForCustomer(
                this.loginService.currentUser.customerId,
                this.catalogService.catalog.language
            )
        );
    }

    async canStartMacro(): Promise<boolean> {
        return this.selectedClassificationSystemId !== "";
    }

    createParameterStringAsJsonString(): string {
        return JSON.stringify({ ClassificationSystemId: this.selectedClassificationSystemId });
    }

    parseParameter(parameter: string) {
        if (!parameter) return;
        try {
            const parsed = JSON.parse(parameter);
            this.selectedClassificationSystemId = parsed.ClassificationSystemId ?? "";
        } catch (error) {
            console.error("Invalid JSON string provided:", error);
        }
    }
}
